import { render, staticRenderFns } from "./right-card.vue?vue&type=template&id=33a48b12&scoped=true&"
import script from "./right-card.vue?vue&type=script&lang=js&"
export * from "./right-card.vue?vue&type=script&lang=js&"
import style0 from "./right-card.vue?vue&type=style&index=0&id=33a48b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a48b12",
  null
  
)

export default component.exports